export enum VirtualKeyboardActionTypes {
  Number = 'number',
  Special = 'special',
  Note = 'note',
  Total = 'total',
}
